import React, { useMemo } from 'react';

import { useFormikContext } from 'formik';
import { ThemeProvider } from 'styled-components';

import { IResourceSubmissionFieldsResourceType } from '../hooks/useResourceSubmissionFields';
import { ResourceSubmissionFieldSubtitle, ResourceSubmissionFieldTitle } from '../styled';
import {
  ResourceSubmissionTypeContainer,
  ResourceSubmissionTypeIconContainer,
  ResourceSubmissionTypeIconImage,
  ResourceSubmissionTypeName,
  ResourceSubmissionTypesWrapper,
  ResourceSubmissionTypeWrapper,
} from './styled';

interface ResourceSubmissionTypeProps {
  name: string;
  resourceTypes?: IResourceSubmissionFieldsResourceType[];
}

export default function ResourceSubmissionType({
  name,
  resourceTypes = [],
}: ResourceSubmissionTypeProps) {
  const formikContext = useFormikContext();

  const handleTypeClick = (value: string) => {
    formikContext.setFieldTouched(name, true);
    if (formikContext.values[name] === value) {
      formikContext.setFieldValue(name, null, true);
    } else {
      formikContext.setFieldValue(name, value, true);
    }
  };

  const isError = useMemo<boolean>(() => {
    return formikContext.errors[name] && formikContext.touched[name];
  }, [formikContext.errors[name], formikContext.touched[name], name]);

  // Don't render if no resource types provided
  if (!resourceTypes || resourceTypes.length === 0) {
    return null;
  }

  return (
    <ThemeProvider theme={{ isError }}>
      <ResourceSubmissionTypeWrapper>
        <input type="hidden" name={name} value={formikContext.values[name] ?? ''} />
        <ResourceSubmissionFieldTitle>Resource Type</ResourceSubmissionFieldTitle>
        <ResourceSubmissionFieldSubtitle isError={isError}>
          {isError ? 'Required. Please select one type.' : 'Required'}
        </ResourceSubmissionFieldSubtitle>
        <ResourceSubmissionTypesWrapper>
          {resourceTypes.map((resourceType) => (
            <ResourceSubmissionTypeContainer
              key={resourceType.uuid}
              active={formikContext?.values[name] === resourceType.slug}
              onClick={() => handleTypeClick(resourceType.slug)}
            >
              <ResourceSubmissionTypeIconContainer>
                <ResourceSubmissionTypeIconImage src={resourceType.icon} alt={resourceType.name} />
              </ResourceSubmissionTypeIconContainer>
              <ResourceSubmissionTypeName>{resourceType.name}</ResourceSubmissionTypeName>
            </ResourceSubmissionTypeContainer>
          ))}
        </ResourceSubmissionTypesWrapper>
      </ResourceSubmissionTypeWrapper>
    </ThemeProvider>
  );
}
